import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconQm3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="qm3, room, transform, xyz, 3d"><path d="M20.25 14.7499H8.75M8.75 14.7499L3.75 20.2499M8.75 14.7499V4.23499" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.25 7.25L8.75 3.75L12.25 7.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconQm3;
